/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { supabase } from '../supabaseClient';

// Masquage avance des coordonnees — Havenly
function maskCoordinates(text, unlocked) {
  if (unlocked) return text;
  let t = text;
  t = t.replace(/0\uFE0F\u20E3/g,'0').replace(/1\uFE0F\u20E3/g,'1').replace(/2\uFE0F\u20E3/g,'2')
       .replace(/3\uFE0F\u20E3/g,'3').replace(/4\uFE0F\u20E3/g,'4').replace(/5\uFE0F\u20E3/g,'5')
       .replace(/6\uFE0F\u20E3/g,'6').replace(/7\uFE0F\u20E3/g,'7').replace(/8\uFE0F\u20E3/g,'8')
       .replace(/9\uFE0F\u20E3/g,'9');
  t = t.replace(/\+33[\s.\-]?[67][\s.\-]?\d{2}[\s.\-]?\d{2}[\s.\-]?\d{2}[\s.\-]?\d{2}/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/0[67][\s.\-_/]?\d[\d\s.\-_/]{6,14}\d/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/\b\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d\b/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/\b0\s+[67](\s+\d){4,}/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/z[e\u00e9]ro[\s\-]?six/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/z[e\u00e9]ro[\s\-]?sept/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/oh[\s\-]?six/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/oh[\s\-]?sept/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/(dernier[s]?\s+chiffre[s]?|finit\s+par|termine\s+par)\s*:?\s*\d+/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/les\s+\d+\s+(dernier[s]?|premier[s]?)\s+chiffre[s]?/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/g, '\uD83D\uDEAB\u00a0[email masqu\u00e9]');
  t = t.replace(/\w[\w.\-]*\s*(arobase|\(at\)|\[at\]| at |_at_|\(a\))\s*\w[\w.\-]*\s*(\.|(\bpoint\b)|(\bdot\b))\s*(com|fr|net|org|io)/gi, '\uD83D\uDEAB\u00a0[email masqu\u00e9]');
  t = t.replace(/[\w.\-_]+\s*[\[\(]?\s*(gmail|yahoo|hotmail|outlook|icloud|free|orange|sfr|laposte)\s*[\]\)]?\s*([.\-_]\s*(com|fr|net))?/gi, '\uD83D\uDEAB\u00a0[email masqu\u00e9]');
  t = t.replace(/\b(whatsapp|telegram|signal|wechat|viber|skype|snapchat|instagram|insta|facebook|fb|tiktok|twitter|linkedin|line)\b/gi, '\uD83D\uDEAB\u00a0[contact masqu\u00e9]');
  t = t.replace(/(retrouve[\s\-]?moi|trouve[\s\-]?moi|cherche[\s\-]?moi|ajoute[\s\-]?moi|rejoins[\s\-]?moi)\s*(sur|on|@)?/gi, '\uD83D\uDEAB\u00a0[contact masqu\u00e9]');
  t = t.replace(/(mon\s+pseudo|mon\s+compte|mon\s+profil)\s*(est|=|:)\s*\S+/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/(cherche|google|recherche)\s+mon\s+(nom|pr[e\u00e9]nom|profil|compte)/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/https?:\/\/[^\s]+/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  t = t.replace(/\b(www\.|wa\.me\/|bit\.ly\/|tinyurl\.com\/|t\.me\/|linktree\.com\/|calendly\.com\/|linktr\.ee\/)[^\s]*/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  t = t.replace(/\b(wa\.me|bit\.ly|tinyurl|linktree|calendly|linktr\.ee|shorturl)\b/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  t = t.replace(/\b\d+\s+(rue|avenue|av\.|boulevard|bd\.|impasse|all[e\u00e9]e|chemin|route|place|square)\s+[\w\u00C0-\u017E\s]+/gi, '\uD83D\uDEAB\u00a0[adresse masqu\u00e9e]');
  t = t.replace(/\b(google[\s]?maps?|maps\.google|apple[\s]?maps?|waze|citymapper)\b/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  return t;
}

export default function ConversationDrawer({ booking, currentUserId, onClose }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  const isHost = currentUserId === booking?.host_id;
  const otherName = isHost
    ? (booking?.guest?.full_name || booking?.guest?.email?.split('@')[0] || 'Voyageur')
    : (booking?.host?.full_name || 'H\u00f4te');

  const listingTitle = booking?.listing?.title || 'Votre s\u00e9jour';
  const dateRange = booking?.date_start && booking?.date_end
    ? new Date(booking.date_start).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }) + ' \u2192 ' + new Date(booking.date_end).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })
    : '';

  const loadMessages = useCallback(async () => {
    if (!booking?.id) return;
    const { data } = await supabase
      .from('messages')
      .select('*')
      .eq('booking_id', booking.id)
      .order('created_at', { ascending: true });
    setMessages(data || []);
    setLoading(false);
    await supabase
      .from('messages')
      .update({ read_at: new Date().toISOString() })
      .eq('booking_id', booking.id)
      .neq('sender_id', currentUserId)
      .is('read_at', null);
  }, [booking?.id, currentUserId]);

  useEffect(() => { loadMessages(); }, [loadMessages]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (!booking?.id) return;
    const channel = supabase
      .channel('messages:' + booking.id)
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'messages',
        filter: 'booking_id=eq.' + booking.id,
      }, (payload) => {
        setMessages(prev => {
          if (prev.find(m => m.id === payload.new.id)) return prev;
          return [...prev, payload.new];
        });
        if (payload.new.sender_id !== currentUserId) {
          supabase.from('messages').update({ read_at: new Date().toISOString() }).eq('id', payload.new.id);
        }
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [booking?.id, currentUserId]);

  const sendMessage = async () => {
    if (!input.trim() || sending) return;
    setSending(true);
    const content = input.trim();
    setInput('');
    const tempMsg = {
      id: 'temp-' + Date.now(),
      booking_id: booking.id,
      sender_id: currentUserId,
      content,
      created_at: new Date().toISOString(),
      read_at: null,
    };
    setMessages(prev => [...prev, tempMsg]);
    const { data: inserted } = await supabase.from('messages').insert({
      booking_id: booking.id,
      sender_id: currentUserId,
      content,
    }).select().single();
    if (inserted) {
      setMessages(prev => prev.map(m => m.id === tempMsg.id ? inserted : m));
    }
    const recipientId = isHost ? booking.guest_id : booking.host_id;
    if (recipientId) {
      await supabase.from('notifications').insert({
        user_id: recipientId,
        type: 'message',
        message: 'Nouveau message de ' + (isHost ? (booking?.host?.full_name?.split(' ')[0] || 'votre h\u00f4te') : otherName) + ' concernant ' + listingTitle,
        booking_id: booking.id,
      });
    }
    setSending(false);
  };

  const formatTime = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    if (diffDays === 1) return 'Hier ' + date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:9998, backdropFilter:'blur(2px)' }}/>
      <div style={{ position:'fixed', right:0, top:0, bottom:0, width:'100%', maxWidth:420, background:'#fff', zIndex:9999, display:'flex', flexDirection:'column', boxShadow:'-8px 0 40px rgba(0,0,0,0.15)', animation:'slideIn 0.25s ease' }}>
        <style>{`@keyframes slideIn { from { transform:translateX(100%); opacity:0; } to { transform:translateX(0); opacity:1; } }`}</style>

        {/* Header */}
        <div style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)', background:'linear-gradient(135deg,#E8F5F0 0%,#fff 100%)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                <div style={{ width:32, height:32, borderRadius:'50%', background:'var(--green-light)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:600, color:'var(--green-mid)', flexShrink:0 }}>
                  {otherName.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div style={{ fontSize:14, fontWeight:600, color:'var(--ink)' }}>{otherName}</div>
                  <div style={{ fontSize:11, color:'var(--ink-3)' }}>{isHost ? 'Voyageur' : 'H\u00f4te Havenly'}</div>
                </div>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:6, marginTop:4 }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--green-mid)" strokeWidth="2"><path d="M3 21V9l9-6 9 6v12"/><path d="M9 21V13h6v8"/></svg>
                <span style={{ fontSize:12, color:'var(--ink-3)' }}>{listingTitle}</span>
                {dateRange && <><span style={{ color:'var(--ink-4)' }}>\u00b7</span><span style={{ fontSize:12, color:'var(--ink-3)' }}>{dateRange}</span></>}
              </div>
            </div>
            <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--ink-3)', fontSize:20, padding:'0 0 0 8px', lineHeight:1 }}>\u00d7</button>
          </div>
          <div style={{ marginTop:10, display:'flex', flexDirection:'column', gap:6 }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:5, background:'#E8F5F0', border:'1px solid var(--green)', borderRadius:20, padding:'3px 10px' }}>
              <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--green)', display:'inline-block' }}/>
              <span style={{ fontSize:11, color:'var(--green-mid)', fontWeight:500 }}>R\u00e9servation confirm\u00e9e</span>
            </div>
            <div style={{ display:'inline-flex', alignItems:'center', gap:5, background:'#FDF0E6', border:'1px solid #E8A87C', borderRadius:20, padding:'3px 10px' }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
              <span style={{ fontSize:11, color:'#C4784A', fontWeight:500 }}>T\u00e9l\u00e9phones, emails et apps de contact masqu\u00e9s</span>
            </div>
          </div>
        </div>

        {/* Messages */}
        <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12, background:'#FAFAF8' }}>
          {loading ? (
            <div style={{ textAlign:'center', fontSize:13, color:'var(--ink-4)', marginTop:40 }}>Chargement...</div>
          ) : messages.length === 0 ? (
            <div style={{ textAlign:'center', padding:'40px 20px' }}>
              <div style={{ fontSize:32, marginBottom:12 }}>💬</div>
              <div style={{ fontSize:14, fontWeight:500, color:'var(--ink)', marginBottom:6 }}>D\u00e9marrez la conversation</div>
              <div style={{ fontSize:13, color:'var(--ink-3)', lineHeight:1.6 }}>
                Coordonnez votre arriv\u00e9e,<br/>l\u2019heure de check-in, les acc\u00e8s...
              </div>
            </div>
          ) : (
            <>
              <div style={{ textAlign:'center', margin:'8px 0' }}>
                <span style={{ fontSize:11, color:'var(--ink-4)', background:'var(--border)', padding:'3px 10px', borderRadius:20 }}>
                  Conversation ouverte apr\u00e8s confirmation de r\u00e9servation
                </span>
              </div>
              {messages.map((msg, i) => {
                const isMe = msg.sender_id === currentUserId;
                const showTime = i === 0 || (new Date(msg.created_at) - new Date(messages[i-1].created_at)) > 5 * 60 * 1000;
                const displayContent = maskCoordinates(msg.content);
                const wasMasked = displayContent !== msg.content;
                return (
                  <div key={msg.id}>
                    {showTime && (
                      <div style={{ textAlign:'center', fontSize:10, color:'var(--ink-4)', margin:'4px 0' }}>
                        {formatTime(msg.created_at)}
                      </div>
                    )}
                    <div style={{ display:'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
                      <div style={{
                        maxWidth:'78%', padding:'9px 13px',
                        borderRadius: isMe ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                        background: isMe ? 'var(--green)' : '#fff',
                        color: isMe ? '#fff' : 'var(--ink)',
                        fontSize:13, lineHeight:1.55,
                        border: isMe ? 'none' : '1px solid var(--border)',
                        boxShadow: isMe ? 'none' : '0 1px 4px rgba(0,0,0,0.06)',
                        opacity: msg.id?.startsWith('temp-') ? 0.6 : 1,
                      }}>
                        {displayContent}
                        {wasMasked && (
                          <div style={{ fontSize:10, marginTop:4, color: isMe ? 'rgba(255,255,255,0.7)' : '#9CA3AF', fontStyle:'italic' }}>
                            Coordonn\u00e9es masqu\u00e9es par Havenly
                          </div>
                        )}
                        {isMe && !msg.id?.startsWith('temp-') && (
                          <div style={{ fontSize:10, opacity:0.7, marginTop:3, textAlign:'right' }}>
                            {msg.read_at ? '\u2713\u2713' : '\u2713'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div ref={bottomRef}/>
            </>
          )}
        </div>

        {/* Input */}
        <div style={{ padding:'12px 16px', borderTop:'1px solid var(--border)', background:'#fff' }}>
          <div style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
            <textarea
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
              placeholder="Votre message..."
              rows={1}
              style={{ flex:1, padding:'10px 14px', border:'1px solid var(--border)', borderRadius:20, fontSize:13, fontFamily:'var(--sans)', outline:'none', resize:'none', lineHeight:1.5, maxHeight:100, overflowY:'auto', background:'var(--surface)' }}
              onInput={e => { e.target.style.height = 'auto'; e.target.style.height = Math.min(e.target.scrollHeight, 100) + 'px'; }}
            />
            <button onClick={sendMessage} disabled={!input.trim() || sending}
              style={{ width:38, height:38, borderRadius:'50%', background: input.trim() ? 'var(--green)' : 'var(--border)', border:'none', cursor: input.trim() ? 'pointer' : 'default', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'background 0.2s' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </button>
          </div>
          <div style={{ fontSize:11, color:'var(--ink-4)', marginTop:6, textAlign:'center' }}>
            Entr\u00e9e pour envoyer \u00b7 Shift+Entr\u00e9e pour sauter une ligne
          </div>
        </div>
      </div>
    </>
  );
}
